import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Box, Flex } from "@chakra-ui/react";
import Dashboard from "./components/Dashboard.js";
import Requests from "./pages/Requests/requests.js";
import Jobs from "./pages/Jobss/jobs.js";
import Approvals from "./pages/Approvals/Approvals";
import StockAlerts from "./pages/StockAlert/StockAlerts.js";
import Modules from "./pages/Modules/Modules.js";
import News from "./pages/News/News.js";
import Announcements from "./pages/Announcements/Announcements.js";
import Clients from "./pages/Clients/Clients.js";
import InvoiceList from "./pages/InvoiceList/InvoiceList.js";
import Profile from "./pages/Profile/Profile.js";

import Layout from "./components/Layout";
import { login, getUser, userManager } from "./authConfig";

const App = () => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const handleSigninRedirectCallback = async () => {
      try {
        await userManager.signinRedirectCallback();
        const user = await getUser();
        setUser(user);
      } catch (err) {
        console.error("Signin callback error:", err);
      }
    };

    if (window.location.pathname === "/callback") {
      handleSigninRedirectCallback();
    } else {
      getUser().then((user) => {
        setUser(user);
        if (!user) {
          login();
        }
      });
    }
  }, []);
  return (
    user ? (
    <Flex>
      <Layout />
      <Box flex="1">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/job" element={<Jobs />} />
          <Route path="/approvals" element={<Approvals />} />
          <Route path="/stock-alerts" element={<StockAlerts />} />
          <Route path="/modules" element={<Modules />} />
          <Route path="/news" element={<News />} />
          <Route path="/announcements" element={<Announcements />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/invoice-list" element={<InvoiceList />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </Box>
    </Flex> ) : null 
  );
};

export default App;
